import React from "react";

const BrochureDownload = () => {
  const driveFileLink = "https://drive.google.com/file/d/1fbnY_81WVLSmYrCHULkxZR4yf9tQQwY9/view?usp=sharing";

  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <h3>Download Our Brochure</h3>
      <a
        href={driveFileLink}
        download
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "inline-block",
          padding: "7px 10px",
          backgroundColor: "#28a745",
          color: "#fff",
          textDecoration: "none",
          borderRadius: "5px",
          fontWeight: "bold",
        }}
      >
        Download
      </a>
    </div>
  );
};

export default BrochureDownload;
